module.exports = __webpack_public_path__ + "static/media/box-arrow-up-right.34c072f6.svg";